import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { LayoutDashboard, Users, ExternalLink, LogOut, ShieldCheck, Newspaper } from "lucide-react";

export default function PlatformLayout() {
  const { user, logout } = useAuth();
  const isSuper = !!user?.is_super_admin;
  const nav = [
    { to: "/platform", label: "Overview", icon: LayoutDashboard, end: true, tid: "pf-nav-overview" },
    { to: "/platform/blog", label: "Blog", icon: Newspaper, tid: "pf-nav-blog" },
  ];
  if (isSuper) nav.push({ to: "/platform/admins", label: "Admins", icon: Users, tid: "pf-nav-admins" });

  const linkCls = ({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-primary/10 text-primary font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted"}`;

  return (
    <div className="min-h-screen bg-background text-foreground flex" data-testid="platform-console">
      <aside className="w-60 border-r border-border p-5 hidden md:flex flex-col shrink-0">
        <Link to="/platform" className="mb-7" data-testid="pf-logo"><Logo /></Link>
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-secondary mb-5 px-1" data-testid="pf-role-badge"><ShieldCheck size={14} /> {isSuper ? "Super owner" : "Admin"}</span>
        <nav className="space-y-1 flex-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.tid} className={linkCls}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-1 pt-4 border-t border-border">
          <a href="/" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted" data-testid="pf-view-site"><ExternalLink size={17} /> View website</a>
          <button onClick={logout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted" data-testid="pf-logout"><LogOut size={17} /> Log out</button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="md:hidden flex items-center justify-between border-b border-border p-4 gap-3">
          <Link to="/platform"><Logo /></Link>
          <div className="flex items-center gap-3">
            {nav.map((n) => <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `text-sm ${isActive ? "text-primary font-medium" : "text-muted-foreground"}`}>{n.label}</NavLink>)}
            <button onClick={logout} data-testid="pf-logout-mobile" className="text-muted-foreground"><LogOut size={18} /></button>
          </div>
        </header>
        <main className="p-6 sm:p-8 max-w-6xl mx-auto"><Outlet /></main>
      </div>
    </div>
  );
}
